export default {
  SET_RESULTS: "SET_RESULTS_GLOBALSEARCH",
  CLEAR_RESULTS: "CLEAR_RESULTS_GLOBALSEARCH",
  STORE_NAME: "globalSearch",
};
